














import { Component, Prop, Vue } from 'vue-property-decorator'
import components from '@/config/components'
@Component
export default class Asider extends Vue {
  components = components

  get defaultActive () {
    return this.$route.path
  }
}
